import axios from "axios";
import { API_BASE_URL, API_TIMEOUT } from '../config';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptores para manejar errores y agregar tokens si es necesario
apiClient.interceptors.request.use(
  (config) => {
    // Agregar token de autenticación si es necesario
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Manejar errores globales, como redirigir al login si el token expira
    if (error.response && error.response.status === 401) {
      // Limpiar todo el localStorage cuando el token expira o no es válido
      localStorage.removeItem("authToken");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("userRole");
      localStorage.removeItem("usuarioId");
      localStorage.removeItem("username");
      localStorage.removeItem("userName");
      localStorage.removeItem("user");
      
      console.log("Token inválido o expirado. Redirigiendo al login...");
      
      // Redirigir al login
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;